// src/components/ReportReviewStatus.jsx
//
// Who has reviewed this report: one chip each for the navigator and the doctor,
// green with a tick once they have, amber "awaiting" until then. The two reviews
// are independent (see ReportReviewCard), so both are always shown. Staff only;
// renders nothing until the status loads, and nothing if it cannot.
import React, { useState, useEffect } from 'react';
import { reportReviewAPI } from '../services/reportReviewApi';
import Icon from './Icon';

const LABEL = { NAVIGATOR: 'Navigator', DOCTOR: 'Doctor' };

const fmtDate = d => (d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '');

function Chip({ review }) {
  const who = LABEL[review.role];
  if (!review.reviewed) {
    return (
      <span className="badge badge-pending review-chip" title={`The ${who.toLowerCase()} has not reviewed this report yet`}>
        <Icon name="clock" size={13} /> {who} review pending
      </span>
    );
  }
  const verdict = review.outcome === 'ADJUSTED' ? 'adjusted' : 'agreed';
  const detail = [review.reviewerName, fmtDate(review.reviewedAt)].filter(Boolean).join(' · ');
  return (
    <span className="badge badge-low review-chip" title={`${who} ${verdict}${detail ? ` · ${detail}` : ''}`}>
      <Icon name="check" size={13} /> {who} reviewed{review.outcome === 'ADJUSTED' ? ' · adjusted' : ''}
      {review.reviewerName && <span className="review-chip-by"> by {review.reviewerName}</span>}
    </span>
  );
}

export default function ReportReviewStatus({ triageResultId }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!triageResultId) return undefined;
    let live = true;
    reportReviewAPI.status(triageResultId)
      .then(res => { if (live) setStatus(res.data); })
      .catch(() => { if (live) setStatus(null); });
    return () => { live = false; };
  }, [triageResultId]);

  if (!status?.navigator || !status?.doctor) return null;
  return (
    <div className="review-chips" role="group" aria-label="Report review status">
      <Chip review={status.navigator} />
      <Chip review={status.doctor} />
    </div>
  );
}
